// extracted by mini-css-extract-plugin
export default {"wrapper":"CourseHeader_wrapper__eY0bT","title":"CourseHeader_title__uXtY6","back":"CourseHeader_back__j1E7H"};